/**
 * [LUZGURU] Galería por variante (fichas FARO con varias variantes y medios marcados « · Ref. <SKU>»).
 *
 * Liquid (snippets/lg-media-variante.liquid) ya pinta, para la variante elegida, solo sus medios (foto, demás fotos,
 * plano, etiqueta) y los comunes. Al cambiar de variante, Dawn (product-info.js, updateMedia) vuelve a pedir la sección
 * y reordena las diapositivas, pero NO las miniaturas: este script, al recibir variantChange, sustituye las miniaturas
 * por las de la sección nueva, las vuelve a enlazar con la galería y recalcula los contadores del carrusel.
 * Solo actúa en galerías con data-lg-media-variante: el resto de fichas siguen siendo Dawn puro.
 */
(function () {
  'use strict';

  function reordenarDiapositivas(lista, listaNueva) {
    if (!lista || !listaNueva) return;
    var nuevos = Array.prototype.slice.call(listaNueva.querySelectorAll(':scope > li[data-media-id]'));
    var ids = function (xs) { return xs.map(function (li) { return li.dataset.mediaId; }).join('|'); };
    // Ya en el orden bueno (lo normal: Dawn lo acaba de hacer): no se mueve nada (mover un iframe lo recarga).
    if (ids(nuevos) === ids(Array.prototype.slice.call(lista.querySelectorAll(':scope > li[data-media-id]')))) return;
    var actuales = {};
    Array.prototype.forEach.call(lista.querySelectorAll(':scope > li[data-media-id]'), function (li) {
      actuales[li.dataset.mediaId] = li;
    });
    var quedan = {};
    nuevos.forEach(function (n) { quedan[n.dataset.mediaId] = true; });
    Object.keys(actuales).forEach(function (id) {
      if (!quedan[id]) actuales[id].remove();
    });
    nuevos.forEach(function (n) {
      var li = actuales[n.dataset.mediaId] || document.importNode(n, true);
      lista.appendChild(li);
    });
  }

  function actualizar(galeria, html, variante) {
    var nueva = html && html.getElementById(galeria.id);
    if (!nueva) return;
    var seccion = galeria.id.replace(/^MediaGallery-/, '');

    // Diapositivas: si la variante tiene foto principal las pone Dawn (product-info.js, updateMedia), que MUEVE las
    // <li> de la sección nueva a la galería: comparar después con esa lista (ya vaciada) borraba todas las fotos y solo
    // quedaba el 3D. Aquí solo se reordena cuando Dawn no lo hace (variante sin foto principal).
    if (!(variante && variante.featured_media)) {
      reordenarDiapositivas(
        galeria.querySelector('[id^="Slider-Gallery-"]'),
        nueva.querySelector('[id^="Slider-Gallery-"]')
      );
    }

    // Miniaturas.
    var comp = galeria.querySelector('[id^="GalleryThumbnails-"]');
    var compNuevo = nueva.querySelector('[id^="GalleryThumbnails-"]');
    if (comp) {
      if (!compNuevo) {
        comp.hidden = true;
      } else {
        comp.hidden = false;
        comp.className = compNuevo.className;
        var ul = comp.querySelector('[id^="Slider-Thumbnails-"]');
        var ulNuevo = compNuevo.querySelector('[id^="Slider-Thumbnails-"]');
        if (ul && ulNuevo) {
          ul.innerHTML = ulNuevo.innerHTML;
          ul.querySelectorAll('[data-target]').forEach(function (li) {
            var boton = li.querySelector('button');
            if (!boton) return;
            boton.addEventListener('click', function () {
              if (typeof galeria.setActiveMedia === 'function') galeria.setActiveMedia(li.dataset.target, false);
            });
          });
        }
        if (comp.slider && typeof comp.resetPages === 'function') comp.resetPages();
      }
    }

    var visor = galeria.querySelector('[id^="GalleryViewer-"]');
    if (visor && visor.slider && typeof visor.resetPages === 'function') visor.resetPages();

    var fm = variante && variante.featured_media && variante.featured_media.id;
    var objetivo = fm ? seccion + '-' + fm : null;
    var primera = galeria.querySelector('[id^="Slider-Gallery-"] > li[data-media-id]');
    if (!objetivo && primera) objetivo = primera.dataset.mediaId;
    if (objetivo && comp && typeof galeria.setActiveThumbnail === 'function') {
      galeria.setActiveThumbnail(comp.querySelector('[data-target="' + objetivo + '"]'));
    }
  }

  function enlazar(intento) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var d = event && event.data;
        if (!d || !d.html) return;
        document.querySelectorAll('media-gallery[data-lg-media-variante]').forEach(function (galeria) {
          if (d.html.getElementById(galeria.id)) actualizar(galeria, d.html, d.variant);
        });
      });
    } else if ((intento || 0) < 50) {
      setTimeout(function () { enlazar((intento || 0) + 1); }, 100);
    }
  }

  if (!window.__lgMediaVariante) {
    window.__lgMediaVariante = true;
    enlazar(0);
  }
})();
